<template>
  <div class="partners-section" v-if="!hideSection">
    <div class="partners-section__content">
      <z-title size="large" color="major" align="center" class="section-parteners__title">
        Tem muita gente usando o Quero Pago.
      </z-title>
      <z-text size="large" color="major" align="center" class="partners-section__description">
        Olha só algumas instituições que já escolheram esse jeito de deixar a vida do aluno mais fácil.
      </z-text>
    </div>

    <carousel class="partners-section__carousel" v-if="parternsLoaded" :auto-play="true">
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="partners-section__partner"
      >
        <z-card class="partner__logo-wrapper">
          <img :alt="partner.name" :src="partner.logo_url" class="partner__logo" aria-valuemax="">
        </z-card>
      </div>
    </carousel>
  </div>
</template>

<script>
import Carousel from 'components/carousel';
import InstitutionService from 'services/InstitutionService';

export default {
  computed: {
    hideSection() {
      return (this.parternsLoaded && !this.partners.length) || this.partnersLoadedError;
    },
  },
  components: {
    Carousel,
  },
  data() {
    return {
      partners: [],
      parternsLoaded: false,
      partnersLoadedError: false,
    };
  },
  beforeMount() {
    this.loadPartners();
  },
  methods: {
    loadPartners() {
      InstitutionService.loadPartners()
        .then(({ data }) => {
          this.partners = data;
        })
        .catch(() => {
          this.partnersLoadedError = true;
        })
        .finally(() => {
          this.parternsLoaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.partners-section {
  background-color: var(--color-background-minor);
  overflow: hidden;
  padding: var(--space-extra-colossal) var(--space-medium);
  width: 100%;

  @media screen and (max-width: $screen-md-max) {
    padding: var(--space-jumbo) var(--space-medium);
  }
}

.partners-section__content {
  margin: 0 var(--space-large);
  position: relative;
  z-index: 1;
}

.section-parteners__title {
  margin-bottom: var(--space-medium);
}

.partners-section__description {
  margin-bottom: var(--space-extra-giant);
}

.partners-section__carousel {
  display: flex;
  justify-content: space-around;
  margin: 0 auto;
  position: relative;
  width: 954px;
  z-index: 1;

  @media screen and (max-width: $screen-md-max) {
    width: 100%;
  }
}

.partners-section__partner:not(:last-child) {
  margin-right: var(--space-extra-large);
}

.partner__logo-wrapper {
  height: 160px;
  overflow: hidden;
  position: relative;
  width: 160px;

  @media screen and (max-width: $screen-md-max) {
    height: 120px;
    width: 120px;
  }
}

.partner__logo {
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - var(--space-medium));
}
</style>
